import { SelectPassThroughAttributes } from 'primevue';
import { computed } from 'vue';

export function getPtClass<T>(ptName: string, pt: T) {
  if (!pt) return;
  if (!pt['value']) return;
  if (!pt['value'][ptName]) return;
  if (!pt['value'][ptName]?.class) return;
  return pt['value'][ptName].class;
}

export function getPt<T>(ptName: string, pt: T, props?: any) {
  if (!pt) return;
  if (!pt['value']) return;
  if (!pt['value'][ptName]) return;
  if (typeof pt['value'][ptName] === 'function') {
    return pt['value'][ptName](props);
  }
  return pt['value'][ptName];
}
/**
 * Is used to v-on all Primevue Listeners dynamcially
 * @param emit
 * @param Component
 * @returns {{listeners: ComputedRef<T>}}
 */
export function useListeners<T>(emit, Component) {
  type ListenersType = {
    [K in keyof T]: (...args: Parameters<T[K]>) => void;
  };

  const listeners = computed<T>(() => {
    return Component.emits?.reduce((acc, eventName) => {
      acc[eventName as keyof T] = ((...args: any[]) => {
        emit(eventName as keyof T, ...args);
      }) as ListenersType[typeof eventName];
      return acc;
    }, {} as ListenersType);
  });

  return { listeners };
}

export declare type PassThroughOptionType<T = any, K = any> =
  | T
  | ((options: K) => T | string)
  | string
  | null
  | undefined;
